import PropTypes from 'prop-types'

import styled from '@emotion/styled'
import {
  FlexItem,
  ICON_FA_VARIANT_SOLID,
  IconFACheck,
  Panel,
  SPACING_24,
  SpacingVertical,
  Text,
  TEXT_VARIANT_BOLD
} from 'mailup-web-components'

import { useRecoilState } from 'recoil'
import { carouselState } from './recoil/carousel'

import { STORE_KEY_ACCOUNT, storeGet } from 'mailup-react-helpers'
import { SLIDE_WIDTH, SPACE_BETWEEN_SLIDE } from './CarouselUtils'

const StyledFlex = styled(FlexItem)`
  position: relative;
`

const StyledPanel = styled(Panel)`
  padding: 0 !important;
  z-index: 999 !important;
  position: relative;
  overflow: hidden !important;
  height: 170px !important;
  width: ${SLIDE_WIDTH}px !important;
  background-color: transparent !important;
  border: 2px solid
    ${({ selected }) => (selected ? 'var(--java)' : 'var(--geyser)')} !important;
  border-radius: 8px !important;
  margin-right: ${SPACE_BETWEEN_SLIDE}px !important;
  margin-bottom: 8px !important;
  cursor: ${({ selected }) => (selected ? 'normal' : 'pointer')} !important;
  flex: 1;

  :hover {
    box-shadow: ${({ selected }) =>
      selected ? 'none' : 'rgb(0 0 0 / 15%) 0px 0px 6px 0px'};
    animation: ${({ selected }) =>
      selected ? 'none' : '0.3s linear 0s 1 normal both running ScaleThumb'};
    @keyframes ScaleThumb {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(1.03);
      }
    }
  }

  img {
    position: absolute;
    left: -2px;
  }
`

const StyledIconCheckContainer = styled.div`
  background-color: #e0f3f9;
  position: absolute;
  top: 45px;
  right: 46px;
  width: 22px;
  height: 22px;
  border-radius: 50px;
  z-index: 1111;
`

const StyledIconCheck = styled(IconFACheck)`
  position: absolute;
  top: 3px;
  right: 3px;
  color: var(--java);

  > svg {
    width: 13px;
    height: 13px;
  }
`

export const Slide = ({ index, text, imgSrc, isFirst }) => {
  const [{ selectedSlide }, setSelectedSlide] = useRecoilState(carouselState)

  const { Domain } = storeGet(STORE_KEY_ACCOUNT)
  const src = `//${Domain}/${imgSrc}`

  const handleClick = () => {
    setSelectedSlide((prev) => ({ ...prev, selectedSlide: index }))
  }

  return (
    <StyledFlex margin={isFirst ? '0 0 0 8px' : ''}>
      <SpacingVertical variant={SPACING_24} />
      {selectedSlide === index && (
        <StyledIconCheckContainer>
          <StyledIconCheck variant={ICON_FA_VARIANT_SOLID} />
        </StyledIconCheckContainer>
      )}
      <StyledPanel
        selected={selectedSlide === index}
        onClick={handleClick}
        isFirst={isFirst}
      >
        <img src={src} />
      </StyledPanel>
      <Text variant={TEXT_VARIANT_BOLD}>{text}</Text>
    </StyledFlex>
  )
}

Slide.propTypes = {
  index: PropTypes.number,
  text: PropTypes.string,
  imgSrc: PropTypes.string,
  isFirst: PropTypes.bool
}
